import { IconArrowRightOutline } from '@icons/IconArrowRightOutline'
import { IconTransformOutline } from '@icons/IconTransformOutline'
import { Button } from '@/components/shadcn/button'
import { ComposedSheet } from '@/components/ui/ComposedSheet'
// import { IconBg } from '@/components/ui/IconBg'
import { Fragment } from 'react/jsx-runtime'
import { stateMap } from './stateMap'
import { TooltipButton } from '@/components/ui/TooltipButton'
import { TooltipWrapper } from '@/components/ui/TooltipWrapper'
import { RestSchemas } from '@/contexts/QueryProvider'
import { ActivityLogV2 } from './ActivityLogV2/ActivityLogV2'
import { useDownloadFile } from './useDownloadFile'
import { IconV2AttachmentOutline } from '@icons/IconV2AttachmentOutline'
import { IconV2FormOutline } from '@icons/IconV2FormOutline'
import { Badge, BadgeProps } from '@/components/shadcn/badge'

type TemplateItemProps = {
  groupName: string
  parentName: string
  item: RestSchemas['Messages.Templates.TTemplateActivity']
}

export function TemplateItem({ groupName, parentName, item }: TemplateItemProps) {
  const { mutate: downloadFile, isPending } = useDownloadFile()
  const hasFileName = !!item.file_name
  const state = item.state as keyof typeof stateMap
  // const StateIcon = stateMap[state].icon
  const stateVariant = stateMap[state].variant

  const handleDownloadFile = () => {
    downloadFile({ url: item.url, fileName: item.file_name })
  }

  return (
    <Fragment key={item.file_template.id}>
      <div className="font-semibold">
        {item.file_template.name}
        {hasFileName ? ':' : null}
      </div>
      <TooltipButton tooltip={`Download '${item.file_name}'`}>
        <Button
          variant="ghost"
          className="h-auto w-full justify-start truncate p-0 underline underline-offset-2"
          onClick={handleDownloadFile}
          disabled={isPending}
        >
          {hasFileName ? <IconV2AttachmentOutline size={16} className="ml-1 flex-shrink-0" /> : null}
          <span className="truncate font-light underline underline-offset-2">{item.file_name}</span>
          {isPending && <IconTransformOutline size={16} className="ml-1 flex-shrink-0" />}
        </Button>
      </TooltipButton>
      <Badge variant={stateVariant as BadgeProps['variant']}>{stateMap[state].name}</Badge>
      {/* <IconBg tooltip={stateMap[state].name} variant={stateVariant} className="size-5">
        <StateIcon size={12} />
      </IconBg> */}
      <div className="flex items-center gap-1 pl-5">
        <TooltipWrapper
          tooltip={`Actions & activity log`}
          wrapTrigger
          triggerComponent={
            <ComposedSheet
              description={
                <span className="flex items-center gap-2">
                  {groupName}
                  <IconArrowRightOutline size={10} />
                  {parentName}
                  <IconArrowRightOutline size={10} />
                  {item.file_template.name}
                </span>
              }
              title={`Actions & activity log`}
              wide
              trigger={undefined}
            >
              <ActivityLogV2 entityId={item.entity.id} templateId={item.file_template.id} />
            </ComposedSheet>
          }
        >
          <Button variant="ghost" size="icon" className="h-5">
            <IconV2FormOutline size={16} />
          </Button>
        </TooltipWrapper>
      </div>
    </Fragment>
  )
}
